import React, { useContext, useState, useEffect } from 'react'
// import { Link } from 'react-router-dom'
import SignupButton from './miniComponents/SignupButton'
import 'C:/apps/ideafy/src/components/styles/MainPage.css'

const FifthSlide = ()=> {
    return (
        <div className = 'fifthSlide'> 
            <h1>Share, BrainStorm, Invent  with IDEAFY</h1>
            <SignupButton/>
        </div>
    )
}

export default FifthSlide 